import axios from "axios";
import UserService from "rc-app/services/UserService";
import { getProjectById } from "./projectActionsApi";

export const createDigitalTwin = async (jsonData) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/mp_digital_twin`;
    const PAYLOAD = {
      ...jsonData
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const editDigitalTwin = async (jsonData, digitalTwinId) => {
  try {
    console.log("create DigitalTwin", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/mp_digital_twin/${digitalTwinId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};


export const getDigitalTwinById = async (digitalTwinId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/mp_digital_twin/${digitalTwinId}?reveal_address=true`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};

export  const getDigitalTwinForProject = async (projectId) => {
    try {
      const res = await getProjectById(projectId);

      // Check if the project and digital_twin_ids exist before proceeding
      const firstTwinId = res.project?.digital_twin_ids?.[0];

      if (!firstTwinId) {
        console.warn("No digital twin ID found for this project");
        return null;
      }

      const digitalTwin = await getDigitalTwinById(firstTwinId);
      console.log("Fetched digitalTwin:", digitalTwin);

      return digitalTwin; // This now returns to the caller
    } catch (error) {
      console.error("Error fetching digital twin:", error);
      throw error;
    }
  };